const BASE_URL = process.env.REACT_APP_BASE_URL_API || 'https://api-dev.eazy.co.id';

const SERVICES = {
  ADMIN: BASE_URL + '/users/v1/admin',
  DEVICE: BASE_URL + '/devices/v1/dashboard-ops/device',
  FEEDBACK: BASE_URL + '/users/v4/feedback',
  ISOLIR: BASE_URL + '/orders/v1/dashboard/isolir/unlock',
  LIST_DEVICE: BASE_URL + '/devices/v4/device/installed',
  LOGIN: BASE_URL + '/users/v1/login/dashboard',
  ONVIF_ENABLE: BASE_URL + '/users/v4/onvif-eligibility',
  USER_SUMMARY: BASE_URL + '/users/v1/user-summary',
};

export default SERVICES;
